import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default [
  {
    exact: true,
    path: '/home/polymerize/audioColumn',
    owner: '/home',
    authority: 'audioColumnList',
    component: Loadable({
      loader: () => import('./index'),
      loading: () => <RouteLoading />
    })
  },
  {
    exact: true,
    path: '/home/polymerize/audioColumn/new',
    owner: '/home',
    authority: 'audioColumnAdd',
    component: Loadable({
      loader: () => import('../edit/new'),
      loading: () => <RouteLoading />
    })
  },
  {
    exact: true,
    path: '/home/polymerize/audioColumn/:id/edit',
    owner: '/home',
    authority: 'audioColumnMod',
    component: Loadable({
      loader: () => import('../edit/mod'),
      loading: () => <RouteLoading />
    })
  }

];